var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotifications(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons_Glyphs_Bell",
    "data-name": "Icons / Glyphs / Bell",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-baseline-notifications"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(8.2 4.884)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_Shape",
    "data-name": "Icon Shape",
    d: "M15.523,37.838a3.886,3.886,0,0,1-3.88-3.882H19.4A3.886,3.886,0,0,1,15.523,37.838Zm15.523-5.822H0v-1.94L3.88,26.2v-9.7A13.767,13.767,0,0,1,6.158,8.615,10.714,10.714,0,0,1,12.612,4.23V2.911a2.911,2.911,0,1,1,5.822,0V4.23a10.729,10.729,0,0,1,6.446,4.393,13.747,13.747,0,0,1,2.285,7.87v9.7l3.88,3.88v1.94Z",
    fill: "#d0d0d0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "ViewBox",
    width: 48,
    height: 48,
    fill: "none"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.5a15ae15f262d19cb582a89ef730ff45.svg";
export { ForwardRef as ReactComponent };